import React from 'react';

import CommonAnimatedLoader from '../../components/common/animated/loader';
import { useTest } from '../../context/test';
import { MessagesContextProvider } from '../../context/messages';
import OrdersResultsQuestionnaireMessagesComponent from '../orders/results-questionnaire-messages';
import QuestionnaireAnswerComponent from '../../components/order/questionnaire-answer';

function TestsResultsQuestionnairePageComponent() {
  const { testView } = useTest();

  return (
    <div>
      {!testView && <CommonAnimatedLoader />}
      {testView && (
        <div className="xl:flex xl:space-x-3 mb-5 pb-5 full-width">
          <div className="w-full xl:w-3/5">
            <div className="bg-white shadow overflow-hidden sm:rounded-lg">
              <div className="px-4 py-5 sm:px-6">
                <h3 className="text-lg leading-6 font-medium text-gray-900">
                  {testView.test.patientIsChild ? (
                    <>
                      For kid: {testView.test.patientName}
                      {testView.test.patientLastName && (
                        <span className="pl-3 inline-flex">{testView.test.patientLastName}</span>
                      )}
                    </>
                  ) : (
                    <>
                      {testView.test.patientName} {testView.test.patientLastName || testView.order?.lastName}
                    </>
                  )}
                </h3>
              </div>
              {testView.questionnaires && testView.test.productKey !== 'TREATMENT_PLAN' && (
                <QuestionnaireAnswerComponent questionnaires={testView.questionnaires} />
              )}
            </div>
          </div>
          <div className="w-full xl:w-2/5 mt-5 xl:mt-0">
            <div className="bg-white shadow overflow-hidden sm:rounded-lg">
              <div className="px-4 py-5 sm:px-6">Create follow-up questions</div>

              <div className="border-t border-gray-200 px-4 py-5 sm:px-6">
                {testView?.order?.customerId ? (
                  <MessagesContextProvider customerId={testView.order.customerId}>
                    <OrdersResultsQuestionnaireMessagesComponent
                      customerId={testView.order.customerId}
                      treatmentPlan3Url={testView?.treatmentPlan3Url}
                      treatmentPlan6Url={testView?.treatmentPlan6Url}
                    />
                  </MessagesContextProvider>
                ) : (
                  <div>The customer is not registered</div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default TestsResultsQuestionnairePageComponent;
